import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { RedirectRequest } from '@azure/msal-browser'
import { AuthService } from '@appShared/services'
import { b2cAuthorities, B2CAuthority_ } from '@appShared/b2c-policies'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { environment } from '@appEnvironments/environment'

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class LandingComponent {
   private _authService = inject(AuthService)
   private _redirectUrl = computed(() => {
      return this._authService.redirectUrl() || `/${SITE_DIRECTORY_ROUTES.content.uri}`
   })

   moduleCourseImagesFolderUri = `${environment.publicCdn.uri}/${environment.publicCdn.moduleCourseImagesFolder}`

   /*
   * private methods
   * */

   /*
   * public methods
   * */

   navigateToLogin() {
      const redirectUrl = this._redirectUrl()

      const b2cAuthority = b2cAuthorities.get(B2CAuthority_.defaultSignUpSignIn)

      this._authService.login({ authority: b2cAuthority.authority, state: redirectUrl } as RedirectRequest)
   }

}
